import { Badge, Group, Stack } from '@mantine/core'
import { sortBy } from 'lodash-es'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { OcrResult } from '@/types/event'
import { ExtractionString } from '../ExtractionString/ExtractionString'
import { OcrBadge } from '../OcrBadge/OcrBadge'

const MAX_OCR_RESULTS = 3

const customOrder = {
  blacklist: 0,
  whitelist: 1,
  other: 2
}

type ListOcrResultsProps = {
  ocrResults: OcrResult[]
}

export const ListOcrResults = ({ ocrResults }: ListOcrResultsProps) => {
  // Sort OCR results by tag priority: blacklist, whitelist, then other.
  // Show only the first 3 results.
  const sortedOcrResults = useMemo(
    () =>
      sortBy(
        ocrResults.filter((ocrResult) => ocrResult.ocr_string),
        (ocrResult) => customOrder[ocrResult.ocr_tag ?? 'other']
      ),
    [ocrResults]
  )

  if (sortedOcrResults.length === 0) {
    return '-'
  }

  const remainingCount = sortedOcrResults.length - MAX_OCR_RESULTS

  return (
    <Stack gap="xs">
      {sortedOcrResults.slice(0, MAX_OCR_RESULTS).map((ocrResult) => (
        <Group
          key={ocrResult.ocr_string + ocrResult.ocr_crop_path}
          wrap="nowrap"
          gap={4}
        >
          <ExtractionString extraction={ocrResult.ocr_string} />
          <OcrBadge tag={ocrResult.ocr_tag} compact />
        </Group>
      ))}

      {remainingCount > 0 && (
        <Badge size="xs" variant="light">
          <FormattedMessage
            id="general.plusMore"
            values={{ count: remainingCount }}
          />
        </Badge>
      )}
    </Stack>
  )
}
